import React, { useEffect, useMemo } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { debounce } from "lodash";

import './index.css';

function SubjectiveComponent({
  subjective = {},
  updateSubjective = () => {},
  clearField = () => {},
  isDisabled = false,
  handleUpdatePNdraft,
}) {

  function handleOnchange (e) {
    e.preventDefault();
    updateSubjective(e);
  }

  function handleClear (name) {
    clearField(name);
  }

  const debouncedSave = useMemo(() => debounce(() => {
    handleUpdatePNdraft()
  }, 5000), []);
  
  useEffect(() => {
    return () => {}
  }, []);

  return (
    <div className="card custom-card">
      <h5 className="card-header ">SUBJECTIVE</h5>
      <div className="card-body" style={{ padding: '10px' }}>
        <div className="custom-form-group-container txt-clr" style={{ margin: '5px' }}>
          <TextareaAutosize 
            id="subjective" 
            name="subjective" 
            type="text" 
            className="form-control custom-textarea" 
            placeholder="Subjective" 
            onChange={e => handleOnchange(e)}
            onBlur={handleUpdatePNdraft}
            value={subjective}
            disabled={isDisabled}
            minRows={2} />
          {!isDisabled && (
            <i 
              className="fal fa-times clear-textarea text-danger"
              onClick={() => handleClear('subjective')} 
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SubjectiveComponent;
